"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timedCounterWidget = void 0;
const widgets_main_1 = require("../widgets-main");
const timedCounterWidget = (currentValue, maxValue, step, updateDelay) => (0, widgets_main_1.onlyIf)(currentValue < maxValue, (0, widgets_main_1.wait)(updateDelay || 5, { key: `timed counter updater` })(() => x => x + (step || 5)));
exports.timedCounterWidget = timedCounterWidget;
